module.exports = __webpack_public_path__ + "static/media/logo.b55aed1b.png";